var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_865_13019",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_865_13019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67476 13.7L10.5498 10.85L8.24976 9H11.0998L11.9998 6.2L12.8998 9H15.7498L13.4248 10.85L14.2998 13.7L11.9998 11.925L9.67476 13.7ZM5.99976 23V15.275C5.36642 14.575 4.87476 13.775 4.52476 12.875C4.17476 11.975 3.99976 11.0167 3.99976 10C3.99976 7.76667 4.77476 5.875 6.32476 4.325C7.87476 2.775 9.76642 2 11.9998 2C14.2331 2 16.1248 2.775 17.6748 4.325C19.2248 5.875 19.9998 7.76667 19.9998 10C19.9998 11.0167 19.8248 11.975 19.4748 12.875C19.1248 13.775 18.6331 14.575 17.9998 15.275V23L11.9998 21L5.99976 23ZM11.9998 16C13.6664 16 15.0831 15.4167 16.2498 14.25C17.4164 13.0833 17.9998 11.6667 17.9998 10C17.9998 8.33333 17.4164 6.91667 16.2498 5.75C15.0831 4.58333 13.6664 4 11.9998 4C10.3331 4 8.91642 4.58333 7.74976 5.75C6.58309 6.91667 5.99976 8.33333 5.99976 10C5.99976 11.6667 6.58309 13.0833 7.74976 14.25C8.91642 15.4167 10.3331 16 11.9998 16ZM7.99976 20.025L11.9998 19L15.9998 20.025V16.925C15.4164 17.2583 14.7874 17.5207 14.1128 17.712C13.4374 17.904 12.7331 18 11.9998 18C11.2664 18 10.5621 17.904 9.88676 17.712C9.21209 17.5207 8.58309 17.2583 7.99976 16.925V20.025Z",
    fill: "#5E6A7D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.484d9eccc032e959ab7d27a3a3f57121.svg";
export { ForwardRef as ReactComponent };